module.exports = __webpack_public_path__ + "static/media/logo-full(en).d53c00da.svg";